// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8dc35caf","455":"bb976075"}[chunkId] + ".chunk.js";
};